
/*
 * LS-2600 sticky desktop header
 */
var fn, hasStickyHeader, header, lastY, offset, onScroll, removeEventListener, removeStickyClass, rtChannel, setEventListener, shouldApply, stickyClass, stickyHeader, tick;

header = void 0;

fn = void 0;

lastY = 0;

offset = 0;

tick = false;

stickyClass = '';

hasStickyHeader = false;


/*
 * Bind sticky header method from scroll event
 * Remove mouse enter event
 * NOTE: function is used externally
 */

setEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.addEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.addEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
};


/*
 * Remove sticky header method to scroll event
 * Add event to show the channel nav, when mouse enters header
 * NOTE: function is used externally
 */

removeEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.removeEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.removeEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
  header.classList.remove(stickyClass);
};


/*
 * Callback to remove sticky class
 *
 * @callback removeStickyClass
 */

removeStickyClass = function() {
  this.classList.remove(stickyClass);
};


/*
 * Scroll callback
 *
 * @callback rtChannel
 */

rtChannel = function() {
  if (!tick) {
    fn(onScroll);
  }
  tick = true;
};


/*
 * Callback animating the header elements
 *
 * @callback onScroll
 */

onScroll = function() {
  var y;
  y = window.scrollY || window.pageYOffset;
  if (lastY < y && y > offset) {
    header.classList.add(stickyClass);
  } else if (lastY > y || y < offset) {
    header.classList.remove(stickyClass);
  }
  lastY = y;
  tick = false;
};


/*
 * Test if sticky header should be applied
 *
 * @returns {Boolean}
 */

shouldApply = function() {
  var $header;
  if (!Groupon.LS.experiments['LS-2600-desktop-sticky-header']) {
    return false;
  }
  if (Groupon.Browsers.ltIE10) {
    return false;
  }
  if (!($header = $('.header-v2')).length) {
    return false;
  }
  if (!$header.hasClass('ls-sticky-header')) {
    return false;
  }
  return true;
};

stickyHeader = {

  /*
   * @param {String} [mode] - Sticky header mode - determines how the header behaves. (Optional)
   */
  init: function(mode) {
    if (mode == null) {
      mode = 'search';
    }
    if (!(hasStickyHeader = shouldApply())) {
      return;
    }
    header = $('.header-v2')[0];
    switch (mode) {
      case 'search':
        stickyClass = 'ls-sticky-search';
        break;
      default:
        stickyClass = 'ls-sticky-channel';
    }
    fn = function(cb) {
      return window.requestAnimationFrame(cb);
    };
    lastY = window.scrollY || window.pageYOffset;
    offset += 1;
    setEventListener();
  },
  pause: function() {
    return removeEventListener();
  },
  resume: function() {
    return setEventListener();
  }
};

module.exports = stickyHeader;

//# sourceMappingURL=data:application/json;base64,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
